
/*
 * LS-2600 sticky desktop header
 */
var fn, hasStickyHeader, header, lastY, offset, onScroll, removeEventListener, removeStickyClass, rtChannel, setEventListener, shouldApply, stickyClass, stickyHeader, tick;

header = void 0;

fn = void 0;

lastY = 0;

offset = 0;

tick = false;

stickyClass = '';

hasStickyHeader = false;


/*
 * Bind sticky header method from scroll event
 * Remove mouse enter event
 * NOTE: function is used externally
 */

setEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.addEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.addEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
};


/*
 * Remove sticky header method to scroll event
 * Add event to show the channel nav, when mouse enters header
 * NOTE: function is used externally
 */

removeEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.removeEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.removeEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
  header.classList.remove(stickyClass);
};


/*
 * Callback to remove sticky class
 *
 * @callback removeStickyClass
 */

removeStickyClass = function() {
  this.classList.remove(stickyClass);
};


/*
 * Scroll callback
 *
 * @callback rtChannel
 */

rtChannel = function() {
  if (!tick) {
    fn(onScroll);
  }
  tick = true;
};


/*
 * Callback animating the header elements
 *
 * @callback onScroll
 */

onScroll = function() {
  var y;
  y = window.scrollY || window.pageYOffset;
  if (lastY < y && y > offset) {
    header.classList.add(stickyClass);
  } else if (lastY > y || y < offset) {
    header.classList.remove(stickyClass);
  }
  lastY = y;
  tick = false;
};


/*
 * Test if sticky header should be applied
 *
 * @returns {Boolean}
 */

shouldApply = function() {
  var $header;
  if (!Groupon.LS.experiments['LS-2600-desktop-sticky-header']) {
    return false;
  }
  if (Groupon.Browsers.ltIE10) {
    return false;
  }
  if (!($header = $('.header-v2')).length) {
    return false;
  }
  if (!$header.hasClass('ls-sticky-header')) {
    return false;
  }
  return true;
};

stickyHeader = {

  /*
   * @param {String} [mode] - Sticky header mode - determines how the header behaves. (Optional)
   */
  init: function(mode) {
    if (mode == null) {
      mode = 'search';
    }
    if (!(hasStickyHeader = shouldApply())) {
      return;
    }
    header = $('.header-v2')[0];
    switch (mode) {
      case 'search':
        stickyClass = 'ls-sticky-search';
        break;
      default:
        stickyClass = 'ls-sticky-channel';
    }
    fn = function(cb) {
      return window.requestAnimationFrame(cb);
    };
    lastY = window.scrollY || window.pageYOffset;
    offset += 1;
    setEventListener();
  },
  pause: function() {
    return removeEventListener();
  },
  resume: function() {
    return setEventListener();
  }
};

module.exports = stickyHeader;

//# sourceMappingURL=data:application/json;base64,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
